
/*
 * LS-2600 sticky desktop header
 */
var fn, hasStickyHeader, header, lastY, offset, onScroll, removeEventListener, removeStickyClass, rtChannel, setEventListener, shouldApply, stickyClass, stickyHeader, tick;

header = void 0;

fn = void 0;

lastY = 0;

offset = 0;

tick = false;

stickyClass = '';

hasStickyHeader = false;


/*
 * Bind sticky header method from scroll event
 * Remove mouse enter event
 * NOTE: function is used externally
 */

setEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.addEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.addEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
};


/*
 * Remove sticky header method to scroll event
 * Add event to show the channel nav, when mouse enters header
 * NOTE: function is used externally
 */

removeEventListener = function() {
  if (!hasStickyHeader) {
    return;
  }
  window.removeEventListener('scroll', rtChannel, {
    passive: true
  });
  if (!header) {
    return;
  }
  header.removeEventListener('mouseenter', removeStickyClass, {
    passive: true
  });
  header.classList.remove(stickyClass);
};


/*
 * Callback to remove sticky class
 *
 * @callback removeStickyClass
 */

removeStickyClass = function() {
  this.classList.remove(stickyClass);
};


/*
 * Scroll callback
 *
 * @callback rtChannel
 */

rtChannel = function() {
  if (!tick) {
    fn(onScroll);
  }
  tick = true;
};


/*
 * Callback animating the header elements
 *
 * @callback onScroll
 */

onScroll = function() {
  var y;
  y = window.scrollY || window.pageYOffset;
  if (lastY < y && y > offset) {
    header.classList.add(stickyClass);
  } else if (lastY > y || y < offset) {
    header.classList.remove(stickyClass);
  }
  lastY = y;
  tick = false;
};


/*
 * Test if sticky header should be applied
 *
 * @returns {Boolean}
 */

shouldApply = function() {
  var $header;
  if (!Groupon.LS.experiments['LS-2600-desktop-sticky-header']) {
    return false;
  }
  if (Groupon.Browsers.ltIE10) {
    return false;
  }
  if (!($header = $('.header-v2')).length) {
    return false;
  }
  if (!$header.hasClass('ls-sticky-header')) {
    return false;
  }
  return true;
};

stickyHeader = {

  /*
   * @param {String} [mode] - Sticky header mode - determines how the header behaves. (Optional)
   */
  init: function(mode) {
    if (mode == null) {
      mode = 'search';
    }
    if (!(hasStickyHeader = shouldApply())) {
      return;
    }
    header = $('.header-v2')[0];
    switch (mode) {
      case 'search':
        stickyClass = 'ls-sticky-search';
        break;
      default:
        stickyClass = 'ls-sticky-channel';
    }
    fn = function(cb) {
      return window.requestAnimationFrame(cb);
    };
    lastY = window.scrollY || window.pageYOffset;
    offset += 1;
    setEventListener();
  },
  pause: function() {
    return removeEventListener();
  },
  resume: function() {
    return setEventListener();
  }
};

module.exports = stickyHeader;

//# sourceMappingURL=data:application/json;base64,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
